export class Menu {
    constructor(public id: number,
                public title: string,
                public iconName: string|null,
                public iconIsSvg:boolean|null,
                public routerLink: string|null,
                public queryParams: any|null,
                public href: string|null, 
                public target: string|null,
                public hasSubMenu: boolean,
                public parentId: number,
                public hidden: boolean,
                public raisedButton: boolean) { }
} 